import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { OfferingsSection } from '../components/OfferingsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-night-900 text-cream-50 font-sans selection:bg-gold-400 selection:text-night-900" data-id="element-173">
      <Navigation data-id="element-174" />
      <main data-id="element-175">
        <HeroSection data-id="element-176" />
        <WelcomeSection data-id="element-177" />
        <OfferingsSection data-id="element-178" />
        <ReviewsSection data-id="element-179" />
        <AboutSection data-id="element-180" />
        <ContactSection data-id="element-181" />
      </main>
      <Footer data-id="element-182" />
    </div>;
}